// Grievances by Days to Close — timeliness distribution (the F585 timeliness story).
// Buckets: 0–2, 3–5, 6–10, 11+ days, still open. Median surfaced prominently.
import React from "react";
import { ReportShell, Card, SectionTitle, MiniBars, KPITile, fmtNum } from "./_shared";
import { daysToClose, median, average, OPEN_STATUSES } from "../grievanceModel";

const BUCKETS = [
  { label: "0–2 days", test: (d) => d != null && d <= 2, color: "var(--ed-success)" },
  { label: "3–5 days", test: (d) => d != null && d >= 3 && d <= 5, color: "#65a30d" },
  { label: "6–10 days", test: (d) => d != null && d >= 6 && d <= 10, color: "#d97706" },
  { label: "11+ days", test: (d) => d != null && d >= 11, color: "var(--ed-alert)" },
];

export default function GrievancesByDaysToClose({ records = [] }) {
  const closeDays = records.map(daysToClose).filter((d) => d != null);
  const med = median(closeDays);
  const avg = average(closeDays);

  const stillOpen = records.filter((r) => OPEN_STATUSES.includes(r.status)).length;
  const within5 = closeDays.filter((d) => d <= 5).length;
  const pctWithin5 = closeDays.length ? Math.round((within5 / closeDays.length) * 100) : null;

  const bars = BUCKETS.map((b) => ({
    label: b.label,
    value: records.map(daysToClose).filter((d) => b.test(d)).length,
    color: b.color,
  }));
  bars.push({ label: "Still open", value: stillOpen, color: "var(--ed-muted-2)" });

  return (
    <ReportShell title="Grievances by Days to Close" subtitle="Timeliness distribution — the F585 timeliness story.">
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 18 }}>
        <KPITile label="Median Days to Close" value={fmtNum(med, 1)} tone={med == null ? "neutral" : med <= 5 ? "green" : med <= 10 ? "yellow" : "red"} sub="resolved + closed" />
        <KPITile label="Average Days to Close" value={fmtNum(avg, 1)} tone={avg == null ? "neutral" : avg <= 5 ? "green" : avg <= 10 ? "yellow" : "red"} />
        <KPITile label="Closed Within 5 Days" value={pctWithin5 == null ? "—" : `${pctWithin5}%`} tone={pctWithin5 == null ? "neutral" : pctWithin5 >= 80 ? "green" : pctWithin5 >= 50 ? "yellow" : "red"} sub={`${within5} of ${closeDays.length}`} />
        <KPITile label="Still Open" value={stillOpen} tone={stillOpen === 0 ? "green" : stillOpen > 6 ? "red" : "yellow"} />
      </div>
      <Card>
        <SectionTitle>Distribution</SectionTitle>
        <MiniBars data={bars} />
      </Card>
    </ReportShell>
  );
}
